export class ReceivingInstructionFileItem {
    docId: string | null;
    fileName: string | null;
    fileExtension: string | null;
    fileType: string | null;
    fileDataUrl: string | null;
  
    constructor() {
        this.docId = null;
        this.fileName = null;
        this.fileExtension = null;
        this.fileType = null;
        this.fileDataUrl = null;
    }
}
